document.addEventListener("DOMContentLoaded", function () {
  // Autofill select → input pairs
  function setupAutoFill(selectName, inputName) {
    const selectEl = document.querySelector(`select[name="${selectName}"]`);
    const inputEl = document.querySelector(`input[name="${inputName}"]`);
    if (!selectEl || !inputEl) return;

    selectEl.addEventListener("change", function () {
      const selectedValue = this.value;
      if (selectedValue) {
        inputEl.value = selectedValue;
      }
    });
  }

  // Set up autofills
  setupAutoFill("role-applying", "role-applied-for");
  setupAutoFill("nursery-location", "setting");

  // Delay date autofill to avoid race conditions with other scripts
  setTimeout(() => {
    const dateInput = document.querySelector(
      'input[name="date-of-application"]'
    );

    if (dateInput) {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = today.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      dateInput.value = formattedDate;
    }
  }, 300); // Delay by 300ms – adjust if necessary

  // document.addEventListener(
  //   "wpcf7mailsent",
  //   function (event) {
  //     location.replace("/message-sent/");
  //   },
  //   false
  // );
});
